import React from 'react';
import YellowMarker from '../images/marker/marker.png'

declare const L: any

const Map: React.FunctionComponent<any> = ({points, selectedPoint, onMarkerSelect, searchMarkerLatLong}) => {
  const initialZoom = 4;
  const initialLocation = [38.967243, -99.771556];
  const focusZoom = 12;
  const searchZoom = 12;

  const [mapInitialized, setMapInitialized] = React.useState(false);
  const [map, setMap] = React.useState({ setView: (x:number[], y:number):void => {}, removeLayer: (marker:any):void => {}});
  const [selected, setSelected] = React.useState(null);
  // eslint-disable-next-line
  const [markers, setMarkers] = React.useState<any[]>([]);
  const [searchMarker, setSearchMarker] = React.useState<any>(null);

  const initializeMap = (points: any) => {
    if (points && points.length > 0 && !mapInitialized) {
      setMapInitialized(true);
      let mymap = L.map('mapid').setView(initialLocation, initialZoom);

      L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 19
      }).addTo(mymap);

      const markersLayer = L.markerClusterGroup();
      mymap.addLayer(markersLayer);

      let CustomIcon = L.Icon.extend({
        options: {
            iconSize: [25, 25],
        }
      });

      let markersArray = [];
      for(let i = 0; i < points.length; i++) {
        const marker = L.marker(
            [points[i].latitude, points[i].longitude], 
            { 
              id: 'marker-' + i, 
              data: points[i], 
              icon: new CustomIcon({
                iconUrl: YellowMarker
              })
            }
          )
          .addTo(mymap)
          .on('click', (event: any) => {
            console.log(event);
            onMarkerSelect(event.target.options.data.id);
          });

        markersArray.push(marker);
        markersLayer.addLayer(marker);
      }

      setMarkers(markersArray)
      setMap(mymap);
    }
  };

  const focusPoint = () => {
    map?.setView([selectedPoint.latitude, selectedPoint.longitude], focusZoom);
  };

  const clearFocus = () => {
    map?.setView(initialLocation, initialZoom);
  };

  const createSearchMarker = () => {    
    const marker = L.circle([searchMarkerLatLong.lat, searchMarkerLatLong.lng], {
      color: 'tranparent',
      fillColor: 'tranparent',
      fillOpacity: 0,
      radius: 100
    }).addTo(map);

    setSearchMarker(marker);
    map?.setView([searchMarkerLatLong.lat, searchMarkerLatLong.lng], searchMarkerLatLong.isStateSearch ? 6 : searchZoom);
  };

  React.useEffect(() => {
    initializeMap(points);
    if (selectedPoint) {
      setSelected(selectedPoint);
    } else {
      setSelected(null);
    }
  // eslint-disable-next-line
  }, [selectedPoint, points]);

  React.useEffect(() => {
    if(selected) {
      focusPoint();
    } else {
      clearFocus();
    }
  // eslint-disable-next-line
  }, [selected]);

  React.useEffect(() => {
    if (searchMarkerLatLong) {
      createSearchMarker();
    } else {
      map?.removeLayer(searchMarker);
      setSearchMarker(null);
      clearFocus();
    }
  }, [searchMarkerLatLong]);

  return (
    <main className="mt-24 h-96 md:w-2/6 md:flex-1	md:mt-0 md:h-screen border-l border-maf-grey">
      <div id="mapid" className="w-full h-full bg-maf-black"></div>
    </main>
  )
}

export default Map;